import SocialFeed from '@/widgets/SocialFeed';
import modal from '@/utils/modal.js';
import eventbus from '@/utils/eventbus';
import state from '@/state';
import hooks from '@/utils/hooks';

function openSocialModal(options) {
  const socialFeedUrl = state.merchantConfig.widgets.urls.socialFeed;

  if (socialFeedUrl) {
    // Hack for going to the social feed url without opening a modal, if set.
    // We need to ensure links to the social feed are real links to this url rather than relying on this hack, for accessibility reasons.
    eventbus.emit('modal.close');

    const data = {
      url: socialFeedUrl,
    };
    const handled = hooks.run('navigation', data);

    if (!handled) {
        window.location = data.url;
    }
    return;
  }

  // @TODO ensure merchant config initialized etc?
  const m = modal.create(SocialFeed, false, {
    provide: {
      defaultFilter: options.filter,
    },
  });
  m.body.setAttribute('data-gmf', ''); // This signals that we are already handling this element (so for example elAttach wont mess with it)
  m.body.classList.add('gmf-social-feed');

  const app = m.app;

  if (options && options.displayHeader) {
    app.displayHeader = true;
  }
  app.inModal = true;

  if (options && options.scrollToCommentId) {
    app.scrollToCommentId(options.scrollToCommentId);
  }
}

eventbus.on('openSocialModal', openSocialModal);

export default openSocialModal;
